<template>
  <div class="gym">
    <Header
      :right-sidebar="true"
      right-sidebar-title="Редактирование спортзала"
    >
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="displayableGymHistoryFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="gymHistoryFields"
            :items="gymHistory"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          button
          variant="warning"
          @click="deleteGym"
          :disabled="loading"
          v-if="!isDeleted"
        >
          Удалить спортзал
          <template #icon>
            <b-icon icon="x-square" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="success"
          @click="restoreGym"
          :disabled="loading"
          v-else
        >
          Восстановить спортзал
          <template #icon>
            <b-icon icon="box-arrow-up-right" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="danger"
          @click="showPurgeConformalModal = true"
          :disabled="loading"
        >
          Удалить спортзал навсегда
          <template #icon>
            <b-icon icon="trash" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <h3 class="text-center">Редактирование спортзала</h3>
      <b-overlay :show="loading">
        <gym-form :value="gymActualData" class="gym__form" />
      </b-overlay>
    </Main>
    <Main>
      <b-overlay :show="loading">
        <h3 class="text-center">История изменений спортзала</h3>
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
    <b-modal
      centered
      title="Окончательное удаление спортзала"
      v-model="showPurgeConformalModal"
      ok-title="Удалить"
      cancel-title="Отмена"
      ok-variant="danger"
      cancel-variant="success"
      @ok="purgeGym"
    >
      <p class="my-4">
        Вы точно хотите удалить этот спортзал?<br />(Клиенты, скидки, их истории
        и прочие связанные с этим спортзалом данные будут безвозвратно удалены)
      </p>
    </b-modal>
    <bottom-overlay v-if="edited">
      <b-button
        @click="updateGym"
        block
        squared
        variant="success"
        class="gym__update-button"
        :disabled="loading"
      >
        Сохранить изменения
      </b-button>
      <b-button
        @click="discardChanges"
        block
        squared
        variant="warning"
        class="gym__discard-changes-button"
        :disabled="loading"
      >
        Отменить изменения
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import GymModel from "@/components/Forms/Gym/models/gymModel";
import Main from "@/components/Layout/Main";
import GymForm from "@/components/Forms/Gym/GymForm";
import BottomOverlay from "@/components/BottomOverlay";
import { displayableFields } from "@/components/Tables/defaultFields";
import { gymHistoryFields } from "@/views/Gyms/models/gymsTableModel";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import pageTitleMixin from "@/mixins/pageTitleMixin";

export default {
  components: {
    BottomOverlay,
    GymForm,
    Main,
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Header
  },
  mixins: [pageTitleMixin],
  props: {
    gymId: {
      type: Number,
      required: true
    }
  },
  data() {
    let displayableGymHistoryFields = displayableFields(gymHistoryFields);
    return {
      gymHistoryFields,
      displayableGymHistoryFields,
      filteredItems: [],
      pickedFields: displayableGymHistoryFields,
      gymHistory: [],
      gymActualData: undefined,
      loading: true,
      showPurgeConformalModal: false
    };
  },
  computed: {
    isDeleted: ({ gymHistory }) =>
      gymHistory[0] !== undefined
        ? Boolean(Number(gymHistory[0].is_deleted))
        : false,
    edited: ({ gymActualData, gymHistory }) =>
      gymHistory[0] !== undefined &&
      JSON.stringify(gymActualData) !==
        JSON.stringify(new GymModel(gymHistory[0])),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    updateGym() {
      this.loading = true;
      this.$store
        .dispatch("gyms/updateGym", {
          id: this.gymId,
          gymData: this.gymActualData
        })
        .then(this.loadData)
        .catch(() => (this.loading = false));
    },
    discardChanges() {
      this.gymActualData = new GymModel(this.gymHistory[0]);
    },
    async deleteGym() {
      this.loading = true;
      await this.$store.dispatch("gyms/deleteGym", this.gymId);
      await this.loadData();
    },
    async restoreGym() {
      this.loading = true;
      await this.$store.dispatch("gyms/restoreGym", this.gymId);
      await this.loadData();
    },
    async purgeGym() {
      this.loading = true;
      await this.$store.dispatch("gyms/purgeGym", this.gymId);
      await this.$router.push("/gyms");
    },
    async loadData() {
      await this.axios.get(`/gyms/${this.gymId}/history`).then(({ data }) => {
        this.gymHistory = data.gym_history;
        this.gymActualData = new GymModel(this.gymHistory[0]);
        this.loading = false;
      });
    }
  },
  async created() {
    await this.loadData();
  }
};
</script>

<style lang="scss">
.gym {
  &__form {
    margin: 0 5px;
  }
}
</style>
